import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

export interface AdminPostDetailsDialogData {
  type: 'sale' | 'accommodation'
  post: any
  media: Array<{ url: string; alt_text?: string }>
}

@Component({
  selector: 'app-admin-post-details-dialog',
  templateUrl: './admin-post-details-dialog.component.html',
  styleUrls: ['./admin-post-details-dialog.component.css'],
})
export class AdminPostDetailsDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AdminPostDetailsDialogData,
    private dialogRef: MatDialogRef<AdminPostDetailsDialogComponent>
  ) {}

  close(): void {
    this.dialogRef.close()
  }

  get post(): any {
    return this.data.post ?? {}
  }

  get title(): string {
    return this.data.type === 'sale' ? 'Sale post details' : 'Accommodation post details'
  }

  get postDetails(): Array<{ label: string; value: string }> {
    if (this.data.type === 'sale') {
      return [
        { label: 'Item name', value: this.formatValue(this.post.item_name) },
        { label: 'Price', value: this.formatValue(this.post._price ?? this.post.price) },
        { label: 'Minimum price', value: this.formatValue(this.post._minimum_price ?? this.post.minimum_price) },
        { label: 'Negotiable', value: this.post.is_item_negotiable ? 'Yes' : 'No' },
        { label: 'Description', value: this.formatValue(this.post.text) },
        { label: 'State', value: this.formatValue(this.post?.Location?.state ?? this.post.state) },
        { label: 'LGA', value: this.formatValue(this.post?.Location?.lga ?? this.post.lga) },
        { label: 'Address', value: this.formatValue(this.post?.Location?.address) },
        { label: 'Posted', value: this.formatValue(this.post.created_at ?? this.post._age) },
        { label: 'Last updated', value: this.formatValue(this.post.updated_at ?? this.post.last_updated_age) },
      ]
    }

    return [
      { label: 'Accommodation type', value: this.formatValue(this.post.accommodation_type) },
      { label: 'Rent', value: this.formatValue(this.post._rent ?? this.post.rent) },
      { label: 'Rent interval', value: this.formatValue(this.post.rent_interval) },
      { label: 'Status', value: this.formatValue(this.post._status ?? this.post.status) },
      { label: 'Available rooms', value: this.formatValue(this.post.available_rooms?.join?.(', ') ?? this.post.available_rooms) },
      { label: 'Ideal roommate', value: this.formatValue(this.post.ideal_roommate) },
      { label: 'Occupant description', value: this.formatValue(this.post.occupant_description) },
      { label: 'Available from', value: this.formatValue(this.post.rent_expire_date) },
      { label: 'State', value: this.formatValue(this.post?.Location?.state ?? this.post.state) },
      { label: 'LGA', value: this.formatValue(this.post?.Location?.lga ?? this.post.lga) },
      { label: 'Address', value: this.formatValue(this.post?.Location?.address) },
      { label: 'Posted', value: this.formatValue(this.post.created_at ?? this.post._age) },
      { label: 'Last updated', value: this.formatValue(this.post.updated_at ?? this.post.last_updated_age) },
    ]
  }

  private formatValue(value: unknown): string {
    if (value === null || value === undefined || value === '') return '-'
    return String(value)
  }
}
